const DEV_URL = "https://devprodapin.precium.in";
// const DEV_URL = "https://test-precium.remotestate.com";
const PROD_URL = "https://apin1.precium.in";

export const BASE_URL =
  process.env.REACT_APP_DEP_TYPE === "development" ? DEV_URL : PROD_URL;
export const V2_ENABLED = process.env.REACT_APP_DEP_TYPE === "development";
export const GOOGLE_MAPS_API_KEY = "AIzaSyDY9XBswhv7HJ6gW9P88gI_GG0PVV1WpAs";
export const DISABLED_DEMAND_LEVELS = ["H+", "D"];
export const errorColor = "#CA3433";
export const successColor = "#228B22";
